import React, { useEffect, useState } from "react";
import Header from "../component/header";
import Footer from "../component/footer";
import { RadioGroup, FormControlLabel, Radio } from "@mui/material";
import axios from "axios";
import config from "../config";

const BASE_IP_URL =
  process.env.IP_URL || "https://ipinfo.io/?token=9415d554205624";

console.log("contactus BASE_IP_URL:", BASE_IP_URL);

const formInit = {
  fullname: "",
  email: "",
  message: "",
  inquireType: "hiring_developer",
};

const inqueryData = [
  {
    value: "hiring_developer",
    label: "Hiring A Developer",
  },
  {
    value: "getting_job",
    label: "Geeting A Job",
  },
  {
    value: "general_question",
    label: "General Question",
  },
];

const Contactus = () => {
  const [formData, setFormData] = useState(formInit);
  const [error, setError] = useState([]);
  const [status, setStatus] = useState("");

  useEffect(() => {
    setTimeout(() => {
      if (status) setStatus("");
    }, 5000);
  }, [status]);

  const onChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
    if (value !== "") {
      setError(error.filter((e) => e !== field));
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const errorList = [];
    ["fullname", "email", "message"].forEach((v) => {
      if (!formData[v]) {
        errorList.push(v);
      }
      if (v === "email" && formData[v]) {
        const isValid = formData[v]
          .toLowerCase()
          .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          );
        if (!isValid) errorList.push("emailNotValid");
      }
    });

    setError(errorList);
    if (errorList.length) return;

    // fetch full ipinfo JSON from frontend
    let clientIpData = null;
    try {
      const ipRes = await axios.get(BASE_IP_URL, {
        timeout: 5000,
      });
      clientIpData = ipRes?.data || null; // full JSON: { ip, city, region, ... }
      console.log("contactus clientIpData", clientIpData);
    } catch (err) {
      // don't block form submit if ipinfo fails — log for debugging
      // eslint-disable-next-line no-console
      console.warn("ipinfo frontend fetch failed:", err?.message || err);
    }

    const data = {
      name: formData.fullname,
      email: formData.email,
      inquireType: inqueryData.find((i) => i.value === formData.inquireType)
        .label,
      details: formData.message,
      clientIpData, // <--- full JSON sent to backend
    };

    try {
      const res = await axios.post(`${config.baseUrl}/contactus`, data);
      if (res.data.success) {
        setFormData(formInit);
        setStatus("sucess");
      } else {
        setFormData(formInit);
        setStatus("error");
      }
    } catch (postErr) {
      console.error("submit error:", postErr);
      setStatus("error");
    }
  };

  return (
    <>
      <Header />
      <section className="contactSection">
        <div className="container">
          <div className="row justify-content-center justify-content-lg-end">
            <div className="col-xl-5 col-lg-6 col-md-6">
              <div className="heading">
                <h3>
                  Contact <span>Us</span>
                </h3>
                <p>Have any questions? We'd love to hear from you.</p>
              </div>
              {status === "sucess" ? (
                <div className="alert alert-success" role="alert">
                  Your details send sucessfully.
                </div>
              ) : null}
              {status === "error" ? (
                <div className="alert alert-danger" role="alert">
                  Something went wrong, try after sometime.
                </div>
              ) : null}
              <form onSubmit={onSubmit}>
                <div className="form-group">
                  <label htmlFor="fullname">
                    Full Name<span className="text-danger ml-2">*</span>
                  </label>
                  <input
                    type="text"
                    name="fullname"
                    maxLength={50}
                    className="form-control"
                    value={formData.fullname}
                    onChange={(e) => onChange("fullname", e.target.value)}
                  />
                  {error.includes("fullname") ? (
                    <p className="text-danger error">Please enter full name.</p>
                  ) : null}
                </div>
                <div className="form-group">
                  <label htmlFor="email">
                    Email<span className="text-danger ml-2">*</span>
                  </label>
                  <input
                    name="email"
                    value={formData.email}
                    className="form-control"
                    maxLength={50}
                    onChange={(e) => onChange("email", e.target.value)}
                  />
                  {error.includes("email") ? (
                    <p className="text-danger error">Please enter email.</p>
                  ) : null}
                  {error.includes("emailNotValid") ? (
                    <p className="text-danger error">
                      Please enter valid Email.
                    </p>
                  ) : null}
                </div>
                <div className="form-group expRadio">
                  <label htmlFor="email">Your Inquiry Is Related To</label>
                  <RadioGroup
                    row
                    aria-labelledby="inquiry"
                    name="inquiry"
                    value={formData.inquireType}
                    onChange={(e) => onChange("inquireType", e.target.value)}
                  >
                    {inqueryData.map((i) => (
                      <FormControlLabel
                        value={i.value}
                        className="radioLabel"
                        control={<Radio />}
                        label={i.label}
                      />
                    ))}
                  </RadioGroup>
                </div>
                <div className="form-group">
                  <label htmlFor="email">
                    How Can We Help You
                    <span className="text-danger ml-2">*</span>
                  </label>
                  <textarea
                    className="form-control"
                    name="message"
                    maxLength={1000}
                    rows={5}
                    cols={10}
                    value={formData.message}
                    onChange={(e) => onChange("message", e.target.value)}
                  ></textarea>
                  {error.includes("message") ? (
                    <p className="text-danger error">Please enter message.</p>
                  ) : null}
                </div>
                <button type="submit" className="btn">
                  <span>Submit</span>
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default Contactus;
